var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    {
      staticClass: "row",
      class: { selected: _vm.isSelected },
      on: {
        click: function ($event) {
          _vm.selectItem(_vm.row), _vm.onEdit()
        },
      },
    },
    [
      _c(
        "td",
        { staticStyle: { width: "20px" } },
        [_c("w-fa", { staticClass: "handle", attrs: { icon: "ellipsis-v" } })],
        1
      ),
      _c("td", { staticStyle: { width: "60px" } }, [
        _vm._v(" " + _vm._s(_vm._f("humanFloat")(_vm.row.Qty, 1)) + " "),
      ]),
      _c(
        "td",
        { staticClass: "description", style: { width: _vm.descriptionWidth } },
        [
          _c("span", { staticClass: "inner-description" }, [
            _vm._v(_vm._s(_vm.row.Name)),
          ]),
          _vm.row.Sku ? _c("small", [_vm._v(_vm._s(_vm.row.Sku))]) : _vm._e(),
          _vm.row.SizeTableEntry
            ? _c("small", [
                _vm._v(
                  _vm._s(_vm.$ct("size")) +
                    ": " +
                    _vm._s(_vm.row.SizeTableEntry.Name)
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm.hasModuleTraceability
        ? _c("td", { staticStyle: { width: "150px" } }, [
            _vm._v(" " + _vm._s(_vm.row.TrackingNumber) + " "),
          ])
        : _vm._e(),
      _vm.hasModuleTraceability
        ? _c("td", { staticStyle: { width: "130px" } }, [
            _vm._v(" " + _vm._s(_vm.formattedTrackingValidUntil) + " "),
          ])
        : _vm._e(),
      _c("td", { staticStyle: { width: "200px" } }, [
        _vm._v(" " + _vm._s(_vm.row.Location) + " "),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "148px" } }, [
        _vm._v(
          " " + _vm._s(_vm._f("humanFloat")(_vm.row.UnitBuyPrice, 2)) + " "
        ),
      ]),
      _c("td", { staticClass: "align-r", staticStyle: { width: "100px" } }, [
        _vm._v(" " + _vm._s(_vm._f("humanFloat")(_vm.row.Total, 2)) + " "),
      ]),
      _c(
        "td",
        { staticStyle: { width: "32px" } },
        [
          _c(
            "w-dropdown",
            {
              attrs: {
                items: _vm.buttonActions,
                flat: "",
                center: "",
                right: "",
              },
              on: {
                click: function ($event) {
                  if (
                    $event.ctrlKey ||
                    $event.shiftKey ||
                    $event.altKey ||
                    $event.metaKey
                  )
                    return null
                  return _vm.trigger($event)
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "bars", size: "xs" } })],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }